module.exports = __webpack_public_path__ + "static/media/pny.9f5934e0.svg";